import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../../shared';
import { RouterModule } from '@angular/router';
import { GERMPLASM_PROGENITORS_ROUTES } from './germplasm-progenitors.route';
import { GermplasmProgenitorsModalComponent, GermplasmProgenitorsPopupComponent } from './germplasm-progenitors-modal.component';
import { GermplasmProgenitorsContext } from './germplasm-progenitors.context';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...GERMPLASM_PROGENITORS_ROUTES]),
    ],
    declarations: [
        GermplasmProgenitorsModalComponent,
        GermplasmProgenitorsPopupComponent
    ],
    providers: [
        GermplasmProgenitorsContext
    ]
})
export class GermplasmProgenitorsModule {
}
